/**
 * @since 2023-04-05
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import ButtonBlue from "components/Shared/ButtonBlue";
import Report from "components/Shared/Report";
import TextError from "components/Shared/TextError";
import TextWait from "components/Shared/TextWait";
import {
  createStrategyAnalysis,
  getStatusStrategyAnalysis,
  loadStrategyPreview,
  waitForStrategyAnalysis,
} from "dataHandling/strategy";
import { useEffect, useState } from "react";

const PreviewChart = ({ email, strategySettings }) => {
  const [status, setStatus] = useState("");
  const [previewData, setPreviewData] = useState();

  useEffect(() => {
    fetchData();
  }, [strategySettings, email]);

  const fetchData = async () => {
    const strategyId = strategySettings.Settings.StrategyId;
    let newStatus = await getStatusStrategyAnalysis(email, strategyId);
    if (newStatus === "WAITING") {
      setStatus(newStatus);
      newStatus = await waitForStrategyAnalysis(email, strategyId);
    }
    if (newStatus === "OK") {
      const newPreviewData = await loadStrategyPreview(email, strategyId);
      setPreviewData(newPreviewData);
    }
    setStatus(newStatus);
  };

  const handleCreateAnalysis = async () => {
    setStatus("WAITING");
    const strategyId = strategySettings.Settings.StrategyId;
    await createStrategyAnalysis(email, strategyId);
    fetchData();
  };

  return (
    <>
      {status === "WAITING" && <TextWait />}
      {status === "ERROR" && (
        <>
          <TextError
            error={
              "Something went wrong, we are working on it. Please try again later."
            }
          />
          <ButtonBlue
            label="CREATE PREVIEW"
            alignment="left"
            height="34px"
            onClick={handleCreateAnalysis}
          />
        </>
      )}
      {status === "NEW" && (
        <ButtonBlue
          label="CREATE PREVIEW"
          alignment="left"
          height="34px"
          onClick={handleCreateAnalysis}
        />
      )}
      {status === "OK" && (
        <>
          <Report
            email={email}
            moduleType={"STRATEGY"}
            moduleId={strategySettings.Settings.StrategyId}
            reportData={previewData}
          />
          <ButtonBlue
            label="REFRESH PREVIEW"
            alignment="left"
            height="34px"
            onClick={handleCreateAnalysis}
          />
        </>
      )}
    </>
  );
};

export default PreviewChart;
